<div class="col-md-10 offset-md-1" style="padding-top: 30px">
    <div class="form-group" *ngIf="users">
        <div class="input-group">
            <input class="form-control" placeholder="Type user name" [(ngModel)]="searchTerms">
            <div class="btn-group" dropdown>
                <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                    data-toggle="tooltip" title="Email all" aria-controls="dropdown-basic">
                    <i class="fa fa-envelope"></i><span class="caret"></span>
                </button>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
                    role="menu" aria-labelledby="button-basic">
                <li role="menuitem"><a class="dropdown-item" href="mailto:?bcc={{mailAllCoord()}}&subject=Important NCBOLD announcement">All coordinators</a></li>
                <li role="menuitem"><a class="dropdown-item" href="mailto:?bcc={{mailNotStarted()}}&subject=Start your NCBOLD submission today">Not started</a></li>
                <li role="menuitem"><a class="dropdown-item" href="mailto:?bcc={{mailNotFinished()}}&subject=Your NCBOLD submission is incomplete">Incomplete</a></li>
                <li class="divider dropdown-divider"></li>
                <li role="menuitem"><a class="dropdown-item" href="mailto:?bcc={{mailAllAdmin()}}&subject=NCBOLD admin announcement">All admins</a></li>
                </ul>
            </div>
            <div class="pull-right">&nbsp;
                <button class="btn btn-primary btn-ncb-wide" [routerLink]="['/user/0/edit']">New User</button>
            </div>
        </div>
    </div> 
    <div class="tableFixHead"> 
        <table>
            <thead>
                <th *ngFor="let col of cols"><a (click)="lh.setOrder(col.name);">
                    <span><i *ngIf="lh.listOrder==col.name" [className]="lh.orderDesc?'fa fa-sort-alpha-desc':'fa fa-sort-alpha-asc'"></i></span>
                    {{col.label}}</a>&nbsp;</th>
            </thead>
            <tbody *ngFor="let user of users">
                <tr *ngIf="filterResults(user)">
                    <td><a *ngIf="filterResults(user)" [routerLink]="['./user',user.id,'edit']" [innerHTML]="user.name | highlight: searchTerms"></a></td>
                    <td><a href="tel: {{user.telephone}}p{{user.teleExt}}">{{user.telephone?.length<10?user.telephone:(user.telephone.slice(0,3)+'-'+user.telephone.slice(3,6)+'-'+user.telephone.slice(6,10)+(user.teleExt?' Ext: '+user.teleExt:''))}}</a></td>
                    <td><a href="mailto:{{user.email}}">{{user.email}}</a></td>
                    <td style="text-align:center"><a [routerLink]="['../authority/','coord',user.id]">{{user.authorities}}</a></td>
                    <td style="text-align:center"><a [routerLink]="['../license/','coord',user.id]">{{user.licenses}}</a></td>
                    <td style="text-align:center" [style.color]="user.updated<95?'red':'green'">{{user.updated}}{{user.updated!==null?'%':''}}</td>
                </tr>            
            </tbody> 
        </table>
    </div>
</div>
